module.exports = __webpack_public_path__ + "static/media/ico_arrow_down_bg.6d09dd96.svg";